module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "fm-title",
    attrs: {
      "id": "fm-1"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_x"
    }
  }, [_vm._v("Abbreviations")])]), _c('a', {
    attrs: {
      "id": "page_x"
    }
  }, [_c('table', [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("AG")])])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Ad Gentes: Decree on the Mission Activity of the Church")]), _vm._v(" (Vatican II). "), _c('a', {
    attrs: {
      "href": "http://www.vatican.va/archive/hist_councils/ii_vatican_council/documents/vat-ii_decree_19651207_ad-gentes_en.html",
      "target": "_blank"
    }
  }, [_vm._v("http://www.vatican.va/archive/hist_councils/ii_vatican_council/documents/vat-ii_decree_19651207_ad-gentes_en.html")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Aquinas, "), _c('em', [_vm._v("ST")])])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("The Summa Theologica of St. Thomas Aquinas")]), _vm._v(". 2nd and rev. ed. 1920. Literally translated by Fathers of the English Dominican Province. Online edition. Copyright © 2008 by Kevin Knight. "), _c('a', {
    attrs: {
      "href": "http://www.newadvent.org/summa/",
      "target": "_blank"
    }
  }, [_vm._v("http://www.newadvent.org/summa/")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Barth, "), _c('em', [_vm._v("CD")])])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Karl Barth. "), _c('em', [_vm._v("Church Dogmatics")]), _vm._v(". Edited by G. W. Bromiley and T. F. Torrance. Translated by G. W. Bromiley. Edinburgh: T. & T. Clark, 1956–1975. Online edition by Alexander Street Press, 1975")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("BC")])])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("The Book of Concord. The Confessions of the Evangelical Lutheran Church")]), _vm._v(". Translated by Theodore G. Tappert. Philadelphia: Fortress, 1959")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("BCSC")])])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("The Blackwell Companion to Science and Christianity")]), _vm._v(". Edited by J. B. Stump and Alan G. Padgett. Malden, Mass., and Oxford: Blackwell, 2012")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("BEM")])])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Baptism, Eucharist and Ministry")]), _vm._v(". Faith and Order, 1982")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "abbr2"
  }, [_c('em', [_vm._v("BEM")]), _vm._v("-B = Baptism section")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "abbr2"
  }, [_c('em', [_vm._v("BEM")]), _vm._v("-E = Eucharist section")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "abbr2"
  }, [_c('em', [_vm._v("BEM")]), _vm._v("-M = Ministry section")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("CA")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Confessio Augustana (= Augsburg Confession)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("CCCIT")])])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("The Cambridge Companion to Classical Islamic Theology")]), _vm._v(". "), _c('a', {
    attrs: {
      "id": "page_xi"
    }
  }, [_vm._v("Edited by Tim Winter. Cambridge: Cambridge University Press, 2008. Online edition")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("CC-LCE")])])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("The Church as Communion: Lutheran Contributions to Ecclesiology")]), _vm._v(". Edited by Heinrich Holze. Geneva: Lutheran World Federation, 1997")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("CTCV")])])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("The Church: Towards a Common Vision")]), _vm._v(". Faith and Order Paper no. 214. 2013")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("CWMRW")])])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Christian Witness in a Multi-Religious World: Recommendations for Conduct")]), _vm._v(". World Council of Churches, Pontifical Council for Interreligious Dialogue, World Evangelical Alliance, 2011")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("DAR")])])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Death and Afterlife: Perspectives of World Religions")]), _vm._v(". Edited by Hiroshi Obayashi. London: Praeger, 1992")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("DIRW")])])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Death and Immortality in the Religions of the World")]), _vm._v(". Edited by Paul Badham and Linda Badham. New York: Paragon House, 1987")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("EPCW")])])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Evangelization, Proselytism, and Common Witness: The Report from the Fourth Phase of the International Dialogue between the Roman Catholic Church and Some Classical Pentecostal Churches and Leaders, 1990–")]), _vm._v("1997. "), _c('a', {
    attrs: {
      "href": "http://www.prounione.urbe.it",
      "target": "_blank"
    }
  }, [_vm._v("http://www.prounione.urbe.it/dia-int/pe-rc/doc/i_pe-rc_pento4.html")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("ER")])])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Encyclopedia of Religion")]), _vm._v(". Edited by Lindsay Jones. 15 vols. 2nd ed. Detroit: Macmillan Reference USA/Gale, Cengage Learning, 2005")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("EWEG")])])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("The End of the World and the Ends of God: Science and Theology on Eschatology")]), _vm._v(". Edited by John Polkinghorne and Michael Welker. Harrisburg, Pa.: Trinity, 2000")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("FFU")])])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("The Far-Future Universe: Eschatology from a Cosmic Perspective")]), _vm._v(". Edited by George F. R. Ellis. Philadelphia and London: Templeton Foundation Press, 2002")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("GDT")])])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Global Dictionary of Theology")]), _vm._v(". Edited by Veli-Matti Kärkkäinen and William Dyrness. Assistant editors, Simon Chan and Juan Martinez. Downers Grove: InterVarsity, 2008")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Haight, "), _c('em', [_vm._v("CCH")])])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Roger Haight, SJ. "), _c('em', [_vm._v("Christian Community in History")]), _vm._v(". Vol. 1, "), _c('em', [_vm._v("Historical Ecclesiology")]), _vm._v(". Vol. 2, "), _c('em', [_vm._v("Comparative Ecclesiology")]), _vm._v(". Vol. 3, "), _c('em', [_vm._v("Ecclesial Existence")]), _vm._v(". New York and London: Continuum, 2004, 2005, 2008")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('a', {
    attrs: {
      "id": "page_xii"
    }
  }, [_c('em', [_vm._v("JBC")])])])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Jesus beyond Christianity: The Classic Texts")]), _vm._v(". Edited by Gregory A. Barker and Stephen E. Gregg. Oxford: Oxford University Press, 2010")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("JWF")])])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Jesus in the World’s Faiths: Leading Thinkers from Five Religions Reflect on His Meaning")]), _vm._v(". Edited by Gregory A. Barker. Maryknoll, N. Y.: Orbis, 2008")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Kasper, "), _c('em', [_vm._v("HTF")])])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Cardinal Walter Kasper. "), _c('em', [_vm._v("Harvesting the Fruits: Basic Aspects of Christian Faith in Ecumenical Dialogue")]), _vm._v(". London and New York: Continuum, 2009")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("LDWR")])])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Life after Death in World Religions")]), _vm._v(". Edited by Harold Coward. Maryknoll, N. Y.: Orbis, 1997")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("LG")])])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Lumen Gentium: The Dogmatic Constitution on the Church")]), _vm._v(". Solemnly Promulgated by His Holiness Pope Paul VI on November 21, 1964 (Vatican II). "), _c('a', {
    attrs: {
      "href": "http://www.vatican.va/archive/hist_councils/ii_vatican_council/documents/vat-ii_const_19641121_lumen-gentium_en.html",
      "target": "_blank"
    }
  }, [_vm._v("http://www.vatican.va/archive/hist_councils/ii_vatican_council/documents/vat-ii_const_19641121_lumen-gentium_en.html")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("LW")])])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Luther’s Works")]), _vm._v(". American ed. (Libronix Digital Library). Edited by Jaroslav Pelikan and Helmut T. Lehman. 55 vols. Minneapolis: Fortress, 2002")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("NMC")])])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("The Nature and Mission of the Church: A Stage on the Way to a Common Statement")]), _vm._v(". Faith and Order Paper no. 198. 2005")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("NPNF")]), _c('sup', [_vm._v("1")])])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("A Select Library of the Nicene and Post-Nicene Fathers of the Christian Church")]), _vm._v(". Edited by Philip Schaff. 1st ser. 14 vols. Edinburgh, 1886. Public domain; available at "), _c('a', {
    attrs: {
      "href": "http://www.ccel.org",
      "target": "_blank"
    }
  }, [_vm._v("www.ccel.org")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("NPNF")]), _c('sup', [_vm._v("2")])])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("A Select Library of the Nicene and Post-Nicene Fathers of the Christian Church")]), _vm._v(". Edited by Philip Schaff and Henry Wace. 2nd ser. 14 vols. Edinburgh, 1890. Public domain; available at "), _c('a', {
    attrs: {
      "href": "http://www.ccel.org",
      "target": "_blank"
    }
  }, [_vm._v("www.ccel.org")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("OBTMR")])])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("One Baptism: Towards Mutual Recognition; A Study Text")]), _vm._v(". Faith and Order Paper no. 210. 2011")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("OHE")])])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Oxford Handbook of Eschatology")]), _vm._v(". Edited by Jerry L. Walls. New York: Oxford University Press, 2009. Online edition")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("OHGR")])])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("The Oxford Handbook of Global Religions")]), _vm._v(". Edited by Mark Juergensmeyer. New York: Oxford University Press, 2006")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("OHM")])])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("The Oxford Handbook of Millennialism")]), _vm._v(". Edited by Catherine Wessinger. New York: Oxford University Press, 2011. Online edition")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('a', {
    attrs: {
      "id": "page_xiii"
    }
  }, [_c('em', [_vm._v("OHRD")])])])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("The Oxford Handbook of Religious Diversity")]), _vm._v(". Edited by Chad Meister. Oxford: Oxford University Press, 2010")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Pannenberg, "), _c('em', [_vm._v("ST")])])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Wolfhart Pannenberg. "), _c('em', [_vm._v("Systematic Theology")]), _vm._v(". Translated by Geoffrey W. Bromiley. 3 vols. Grand Rapids: Eerdmans, 1991, 1994, 1998")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("PC")])])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Physics and Cosmology: Scientific Perspectives on the Problem of Natural Evil")]), _vm._v(". Edited by Nancey Murphy, Robert John Russell, William R. Stoeger, SJ. Vol. 1. Vatican City and Berkeley, Calif.: Vatican Observatory and Center for Theological and the Natural Sciences, 2007")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("PE")])])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("The Problem of Evil")]), _vm._v(". Edited by M. M. Adams and R. M. Adams. Oxford: Oxford University Press, 1990")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Pelikan, "), _c('em', [_vm._v("CT")])])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Jaroslav Pelikan. "), _c('em', [_vm._v("The Christian Tradition: A History of the Development of Doctrine")]), _vm._v(". Vol. 1, "), _c('em', [_vm._v("The Emergence of the Catholic Tradition (100–600)")]), _vm._v(". Vol. 2, "), _c('em', [_vm._v("The Spirit of Eastern Christendom (600–1700)")]), _vm._v(". Vol. 3, "), _c('em', [_vm._v("The Growth of Medieval Theology (600–1300)")]), _vm._v(". Vol. 4, "), _c('em', [_vm._v("Reformation of Church and Dogma (1300–1700)")]), _vm._v(". Chicago: University of Chicago Press, 1971, 1974, 1978, 1984")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("PIR")])])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Personal Identity and Resurrection: How Do We Survive Our Death?")]), _vm._v(" Edited by Georg Gasser. Surrey, UK: Ashgate, 2010")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("QCLN")])])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Quantum Cosmology and the Laws of Nature: Scientific Perspectives on Divine Action")]), _vm._v(". Edited by Robert John Russell, Nancey Murphy, and C. J. Isham. Vatican City: Vatican Observatory Publications, 1993")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("RCCC")])])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Routledge Companion to the Christian Church")]), _vm._v(". Edited by Gerard Mannion and Lewis S. Mudge. New York: Routledge, 2012")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("RTSA")])])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Resurrection: Theological and Scientific Assessments")]), _vm._v(". Edited by T. Peters, R. J. Russell, and M. Welker. Grand Rapids: Eerdmans, 2002")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("SBE")])])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Sacred Books of the East")]), _vm._v(". Translated by Max Müller. 50 vols. Oxford: Oxford University Press, 1879–1910. Also available at "), _c('a', {
    attrs: {
      "href": "http://www.sacred-texts.com",
      "target": "_blank"
    }
  }, [_vm._v("www.sacred-texts.com")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Schleiermacher, "), _c('em', [_vm._v("CF")])])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Friedrich Schleiermacher. "), _c('em', [_vm._v("The Christian Faith")]), _vm._v(". Edited by H. R. Mackintosh and J. S. Stewart. London and New York: T. & T. Clark, 1999")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("SPDA")])])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Scientific Perspectives on Divine Action: Twenty Years of "), _c('a', {
    attrs: {
      "id": "page_xiv"
    }
  }, [_vm._v("Challenge and Progress")])]), _c('a', {
    attrs: {
      "id": "page_xiv"
    }
  }, [_vm._v(". Edited by Robert John Russell, Nancey Murphy, and William R. Stoeger, SJ. Vatican City and Berkeley, Calif.: Vatican Observatory and Center for Theological and the Natural Sciences, 2008")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("TCW")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("“Towards Common Witness: A Call to Adopt Responsible Relationships in Mission and to Renounce Proselytism.” WCC and the Vatican, 1997")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Tillich, "), _c('em', [_vm._v("ST")])])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Paul Tillich. "), _c('em', [_vm._v("Systematic Theology")]), _vm._v(". 3 vols. Chicago: University of Chicago Press, 1951, 1957, 1963")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("TTL")])])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Together towards Life: Mission and Evangelism in Changing Landscapes")]), _vm._v(". Commission on World Mission and Evangelism/WCC, 2012")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("UR")])])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Unitatis Redintegratio: Decree on Ecumenism")]), _vm._v(" (Vatican II)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("WA")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Weimarer Ausgabe (the Weimar edition of Luther’s works)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("WCC")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("World Council of Churches")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("Bible references, unless otherwise indicated, are from the Revised Standard Version of the Bible, copyright 1952 (2nd ed. 1971) by the Division of Christian Education of the National Council of the Churches of Christ in the United States of America. Used by permission. All rights reserved.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Unless otherwise indicated, all citations from patristic writers come from the standard series listed above.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_x"
    }
  }, [_vm._v("Josephus’s writings are from the Sacred Texts Web site: ")]), _c('a', {
    attrs: {
      "href": "http://www.sacred-texts.com/jud/josephus/index.htm",
      "target": "_blank"
    }
  }, [_vm._v("http://www.sacred-texts.com/jud/josephus/index.htm")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Unless otherwise indicated, contemporary Roman Catholic documents, documents of Vatican II, papal encyclicals, and similar works are quoted from the official Vatican Web site: "), _c('a', {
    attrs: {
      "href": "http://www.vatican.va",
      "target": "_blank"
    }
  }, [_vm._v("www.vatican.va")]), _vm._v(". This includes also dialogue documents with Lutherans, Reformed, Anglicans, Methodists, and Pentecostals.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Contemporary World Council of Churches documents are quoted from their official Web site, "), _c('a', {
    attrs: {
      "href": "http://www.oikoumene.org/",
      "target": "_blank"
    }
  }, [_vm._v("http://www.oikoumene.org/")]), _vm._v(", unless otherwise indicated.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The sources used for postbiblical Jewish literature are as follows:")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Midrashic commentary literature is from "), _c('em', [_vm._v("Midrash Rabbah")]), _vm._v(". Translated and edited by H. Freedman and Maurice Simon. 10 vols. 3rd imprint. London: Soncino Press, 1961 (1939). Available at "), _c('a', {
    attrs: {
      "href": "https://archive.org/details/RabbaGenesis",
      "target": "_blank"
    }
  }, [_vm._v("https://archive.org/details/RabbaGenesis")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Talmud references are from "), _c('em', [_vm._v("The Babylonian Talmud")]), _vm._v(". Translated and edited by I. Epstein. 35 vols. London: Soncino Press, 1952. Available at "), _c('a', {
    attrs: {
      "href": "http://www.come-and-hear.com/tcontents.html",
      "target": "_blank"
    }
  }, [_vm._v("http://www.come-and-hear.com/tcontents.html")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_xv"
    }
  }, [_vm._v("Mishnah texts are from ")]), _c('a', {
    attrs: {
      "href": "http://eMishnah.com",
      "target": "_blank"
    }
  }, [_vm._v("eMishnah.com")]), _vm._v(" (2008) at "), _c('a', {
    attrs: {
      "href": "http://www.emishnah.com/Yoma.html",
      "target": "_blank"
    }
  }, [_vm._v("http://www.emishnah.com/Yoma.html")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("All others, unless otherwise noted, are from "), _c('a', {
    attrs: {
      "href": "http://www.earlyjewishwritings.com/",
      "target": "_blank"
    }
  }, [_vm._v("http://www.earlyjewishwritings.com/")]), _vm._v(" (e.g., Philo of Alexandria).")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The Qur’anic references, unless otherwise indicated, are from "), _c('em', [_vm._v("The Holy Qur’ān: A New English Translation of Its Meanings")]), _vm._v(" © 2008 Royal Aal al-Bayt Institute for Islamic Thought, Amman, Jordan. This version of the Qur’an is also available online at "), _c('a', {
    attrs: {
      "href": "http://altafsir.com",
      "target": "_blank"
    }
  }, [_vm._v("http://altafsir.com")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Hadith texts are from the Hadith Collection Web site: "), _c('a', {
    attrs: {
      "href": "http://www.hadithcollection.com/",
      "target": "_blank"
    }
  }, [_vm._v("http://www.hadithcollection.com/")]), _vm._v(" (2009–).")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Buddhist texts, unless otherwise indicated, are from “Tipitaka: The Pali Canon.” Edited by John T. Bullitt. "), _c('em', [_vm._v("Access to Insight")]), _vm._v(", May 10, 2011. Available at "), _c('a', {
    attrs: {
      "href": "http://www.accesstoinsight.org/tipitaka/index.html",
      "target": "_blank"
    }
  }, [_vm._v("http://www.accesstoinsight.org/tipitaka/index.html")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Bhagavad-Gita texts are from the translation by Ramanand Prasad. EAWC Anthology, 1988.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("All other Hindu texts, unless otherwise indicated, are from the Sacred Texts Web site: "), _c('a', {
    attrs: {
      "href": "http://www.sacred-texts.com/hin/index.htm",
      "target": "_blank"
    }
  }, [_vm._v("http://www.sacred-texts.com/hin/index.htm")]), _vm._v(".")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cec86318","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/005_Abbreviations.vue
// module id = 69
// module chunks = 0